<template>
  <div class="PlatformSlider">
    <!-- <SectionHeader label="Verbonden Platforms &amp; Organisaties" /> -->

    <ul class="PlatformSlider__items">
      <li v-for="logo in logos" :key="logo.name">
        <a :href="logo.href" target="_blank">
          <img :src="`/images/partners/Logo_${logo.name}.png`" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
// import SectionHeader from '@/components/section/Header';

export default {
  name: 'PlatformSlider',
  data() {
    return {
      partners: [
        {
          name: 'ANNE',
          href: 'https://anne-online.nl'
        },
        {
          name: 'DuurzameHuizenRoute',
          href: 'duurzame huizen'
        },
        {
          name: 'Energie-U',
          href: 'https://www.energie-u.nl'
        },
        {
          name: 'HomeMates',
          href: 'http://www.homemates.nl'
        },
        {
          name: 'JouwHuisSlimmer',
          href: 'https://jouwhuisslimmer.nl'
        },
        {
          name: 'MilieuCentraal',
          href: 'https://www.milieucentraal.nl'
        },
        {
          name: 'StroomVersnelling',
          href: 'https://stroomversnelling.nl'
        }
      ],
      offset: 0,
      shuffleTimer: null
    }
  },
  // components: {
  //   SectionHeader
  // },
  computed: {
    logos() {
      this.reshuffle();
      return this.shuffle(this.partners).slice(this.offset, 3 + this.offset);
    }
  },
  methods: {
    reshuffle() {
      if (this.shuffleTimer !== null) {
        clearTimeout(this.shuffleTimer);
      }
      this.shuffleTimer = setTimeout(() => {
        this.offset = this.offset === 1 ? 0 : 1;
      }, 30 * 1000);
    },
    shuffle(array) {
      let counter = array.length;

      // While there are elements in the array
      while (counter > 0) {
          // Pick a random index
          let index = Math.floor(Math.random() * counter);

          // Decrease counter by 1
          counter--;

          // And swap the last element with it
          let temp = array[counter];
          array[counter] = array[index];
          array[index] = temp;
      }

      return array;
    }
  }
}
</script>

<style lang="scss">
  .PlatformSlider {
    position: absolute;
    bottom: 30px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    min-width: 500px;

    // .SectionHeader {
    //   z-index: 1;
    //   opacity: 0.99;
    //   position: absolute;
    //   top: -25px;
    //   right: 25px;
    //   margin: 0;
    //   color: black;
    //   width: 90%;
    //   max-width: 525px;
    //   text-shadow: 2px 2px #fff;
    //   user-select: none;

    //   &:after, &:before {
    //     height: 2px;
    //     background-color: black;
    //     border-bottom: 1px solid white;
    //   }
    // }

    &__items {
      list-style: none;
      margin: 0 0 10px;
      padding: 0;
      display: flex;
      user-select: none;

      li {
        padding: 5px;
        background: white;
        margin-right: 24px;
        box-shadow: 0 0.125rem 0.8125rem rgba(0, 0, 0, 0.28);
      
        a {
          display: flex;
          height: 94px;
          width: 190px;
          
          align-content: center;
          align-items: center;
          justify-content: center;
          text-decoration: none;
        }
      }
    }

  }
</style>
